module.exports = __webpack_public_path__ + "img/small-6.ff3cee5d.jpg";